"use strict";

if (!customElements.get("buy-buttons-low-stock")) {
  customElements.define(
    "buy-buttons-low-stock",
    class BuyButtonsLowStock extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector(".product-form__low-stock-text");
        this._onVariantChange = this._onVariantChange.bind(this);
        document.addEventListener("variant:change", this._onVariantChange);
      }

      disconnectedCallback() {
        document.removeEventListener("variant:change", this._onVariantChange);
      }

      _onVariantChange(event) {
        const detail = event.detail || {};
        if (detail.sectionId && detail.sectionId !== this.dataset.sectionId) return;
        if (!detail.variant) return;
        this._update(detail.variant);
      }

      _update(variant) {
        const showAlways = this.dataset.showAlways === "true";
        const showThreshold = this.dataset.showThreshold === "true";
        const threshold = parseInt(this.dataset.threshold, 10) || 10;
        const textAlways = this.dataset.textAlways || "";
        const countTemplate = (this.dataset.textCountTemplate || "").replace(
          "__COUNT__",
          String(variant.inventory_quantity)
        );

        let show = false;
        let text = "";

        if (!variant.available) {
          this.classList.add("hidden");
          return;
        }

        if (showAlways) {
          show = true;
          text = textAlways;
        } else if (showThreshold && variant.inventory_management) {
          const qty = variant.inventory_quantity;
          if (qty > 0 && qty <= threshold) {
            show = true;
            text = countTemplate;
          }
        }

        if (show) {
          if (this.textEl) this.textEl.textContent = text;
          this.classList.remove("hidden");
        } else {
          this.classList.add("hidden");
        }
      }
    }
  );
}
